import React from 'react';
import styled from 'styled-components';
import Tick1 from '../../../../shared/components/Icon/components/Tick1';
import X1 from '../../../../shared/components/Icon/components/X1';
import Image from '../../../../shared/components/Image';
import { DataRow, SubHeading, TableBody } from '../../../../shared/components/Table';
import { borders, colors } from '../../../../shared/lib/styles';
import { space2, space6 } from '../../../../shared/settings/spaces';
import { between } from '../../../../shared/spa/core-components/utils/media';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import { Product } from './bundles';

const StyledSubHeading = styled(SubHeading)`
    position: absolute;
    margin-top: -56px;
    border-bottom: none !important;

    ${between('small', 'medium')} {
        background: ${colors.grey100};
        margin-top: -42px;
        margin-right: 30px;
    }
`;

const StyledDataRow = styled(DataRow)`
    border-bottom: ${borders.content};

    border-top: ${(props: StyledDataRow) => (props.isFirstElement ? `${borders.content}` : 'none')};

    td {
        background-color: ${colors.grey100};
    }

    &:last-child {
        border-bottom: none;

        td {
            ${(props: StyledDataRow) =>
                props.isLastSection
                    ? `border-bottom-left-radius: ${space6}px;
                border-bottom-right-radius: ${space6}px;`
                    : 'padding-bottom: 6rem;'}
        }
    }
`;

interface Features {
    [index: string]: string;
}

interface StyledDataRow {
    isFirstElement: boolean;
    isLastSection: boolean;
}

interface ProductFeaturesSectionProp {
    title: string;
    logoUrl?: string;
    bundleProducts: Product[];
    features: Features;
    isLastSection: boolean;
}
export function ProductFeaturesSection({
    title,
    logoUrl,
    bundleProducts,
    features,
    isLastSection,
}: ProductFeaturesSectionProp) {
    const iconSize = 21;
    return (
        <tbody>
            <StyledSubHeading colSpan={bundleProducts.length}>
                {logoUrl ? <Image src={publicImageUrl(logoUrl)} alt={title} /> : title}
            </StyledSubHeading>
            {Object.keys(features).map((featureId, index) => {
                const values = bundleProducts.map((product) => {
                    const productFeature = product.features.find(
                        (product) => product.id === featureId
                    );

                    if (!productFeature) {
                        return (
                            <X1
                                color={colors.grey500}
                                width={iconSize}
                                height={iconSize}
                                aria-label="No"
                            />
                        );
                    }
                    if (typeof productFeature.value === 'undefined') {
                        return (
                            <Tick1
                                color={colors.grey800}
                                width={iconSize}
                                height={iconSize}
                                aria-label="Yes"
                            />
                        );
                    }
                    return productFeature.value;
                });
                return (
                    <StyledDataRow
                        key={index}
                        colSpan={bundleProducts.length}
                        title={features[featureId]}
                        values={values}
                        isFirstElement={index === 0}
                        isLastSection={isLastSection}
                    />
                );
            })}
        </tbody>
    );
}
